module.exports = __webpack_public_path__ + "static/media/about.d60ad997.jpg";